<template>
  <div> 
    <ScoreStartArmyPro :row="row.start"  :list="row.list" :start="row.start.subject" v-if="proShow &&  row.start.subject!=''"></ScoreStartArmyPro>
    <ScoreStartArmy2 :row="row.start"  :list="row.list" :start="row.start.subject" v-if="!proShow && row.start.subject!=''"></ScoreStartArmy2>
 
  </div>
</template>

<script>
import {Toast} from "vant";
import ScoreStartList2 from "@/components/score/ScoreStartList2.vue";
import ScoreStartArmy2 from "@/components/score/ScoreStartArmy2.vue";
import ScoreStartArmyPro from "@/components/score/ScoreStartArmyPro.vue";
import ScoreStartSubjectRank2 from "@/components/score/ScoreStartSubjectRank2.vue";
export default {
  name: "ScoreShowPro",
  data: function () {
    return {
      show_type:0,
      proShow:true,
      last_id:0,
      row: {
        start: {
          current_show_type: 0,
          subject:{
            id:0,
          }
        },
        list: [],
        rank_list: []
      }
    }
  },
  components: {
    ScoreStartList2, ScoreStartArmy2, ScoreStartSubjectRank2,ScoreStartArmyPro
  },
  filters: {},
  watch:{
    // 'row.start.subject.id': function(newVal, oldVal) {
    //   console.log('subject_id 变了', newVal, oldVal);
    // },
  },
  mounted() {
    let that = this;
    document.title="数据展示"
    that.fetch() 
    // 换成轮询
    that.timer = setInterval(function () {
      that.fetch()
    }, 2000)
  },
  destroyed() {
    // 销毁监听
    // this.socket.close()
    clearInterval(this.timer)
  },
  methods: {
    fetch() {
      let that = this;
      let url = ''; 
        url = '/api/dscore/scoreShowInfo' 
      that.$api.post(url, {
        saiqu: that.$route.query.saiqu,
        start_id: that.$route.query.start_id,
      }, (res) => {
        that.row = res.data; 
        if(that.last_id!=that.row.start.subject.id){
          that.proShow = false
          setTimeout(()=>{
            that.proShow = true
            setTimeout(()=>{
              that.proShow = false
            },20000)
          },100)
        }
        that.last_id = that.row.start.subject.id
        console.log(that.last_id); 
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ScoreShowPro.vue?6e84a67a